/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var FlowModeEnum;

(function (FlowModeEnum) {
  FlowModeEnum["STANDARD"] = "standard";
  FlowModeEnum["VANILLA"] = "vanilla";
})(FlowModeEnum || (FlowModeEnum = {}));